/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
var iswHideVendorList = ["6009", "81702", "82338", "83316", "83432", "83900", "83980", "84643", "84864", "84883", "84913", "85464", "85828", "fcl", "befame", "lcl", "venture", "cs", "designlink", "china", "twenty", "actona", "unique", "furniture", "malaysia", "connect", "cavo", "house", "nordic", "dominari", "tvilum", "ukraine", "turkey", "house", "nordic", "poland", "doing", "goods", "present", "time", "core", "one", "lexpo", "jakobsen", "home", "jakobsen", "home", "design", "link", "guardian", "liv", "interior"];

// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  // Fix search redirect - conflict theme js
    const getSearchRedirectUrl = () => {
    	if (typeof Globals.currentTerm !== 'string'){
    		Globals.currentTerm = Utils.stripHtml(Globals.currentTerm.toString());
    	}
    	Globals.currentTerm = Utils.stripHtml(Globals.currentTerm.trim());
    
    	var redirectUrl = '';
    	if (Globals.suggestionCache.hasOwnProperty(Utils.unescape(Globals.currentTerm))) {
    		var cachedResult = Globals.suggestionCache[Utils.unescape(Globals.currentTerm)];
    		cachedResult.forEach((result) => {
    			if (result.key == 'redirect' && result.values) {
    				// Check is there is a redirect
    				redirectUrl = result.values;
    				redirectUrl = redirectUrl.replace('https://' + Globals.shopDomain, '');
    				redirectUrl = redirectUrl.replace('http://' + Globals.shopDomain, '');
    			}
    		});
    	}
    	return redirectUrl;
    }

  const mySearchBtn = document.querySelectorAll('form[action="/search"] button[type="submit"]');
    mySearchBtn.forEach(function(el){
      let new_el = el.cloneNode(true);
      el.after(new_el);
      el.remove();
      new_el.addEventListener('click', function(e) {
        // e.stopImmediatePropagation();
        // e.stopPropagation();
        // e.preventDefault();
        if(Object.entries(Globals.suggestionCache).length > 0){
          var redirectUrl = getSearchRedirectUrl();
          if (redirectUrl) {
              Utils.setWindowLocation(redirectUrl);
          } else {
              // document.querySelectorAll('form[action="/search"]')[0].submit();
          }
        }else{
          jQ('[name="q"]').click();
        }
      });
    });

    SearchInput.prototype._bindAutoCompleteSource = function(request, response) {
		window.suggestionCallback = response;
		Globals.currentTerm = Utils.stripHtml(request.term);
		var term = (request.term).trim().replace(/\s+/g, ' ');
		if (term != '') {
          
            // Hide vendor group
            var isExcluded = false;
            var lowerTerm = term.toLowerCase();
            for (let i = 0; i < iswHideVendorList.length; i++) {
              if(iswHideVendorList[i].includes(lowerTerm)){
                isExcluded = true;
              }
            }
            for (let i = 0; i < iswHideVendorList.length; i++) {
              if(lowerTerm.includes(iswHideVendorList[i])){
                isExcluded = true;
              }
            }
            if(isExcluded){
              jQ('body').addClass('boost-pfs-hide-isw-other-groups');
            }else{
              jQ('body').removeClass('boost-pfs-hide-isw-other-groups');
            }
          
			var $instantSearchResult = this.searchAutoComplete.$element;
			this.instantSearchResult.setData($instantSearchResult, null, true);
			this.instantSearchResult.refresh();
			if (Globals.suggestionCache.hasOwnProperty(term)) {
				window.suggestionCallback(Globals.suggestionCache[term]);
				return;
			}
			term = encodeURIComponent(term);
			InstantSearchApi.getSuggestionData(term, 0, 'suggest');
		}
	};

})();

(function() {
  var cache = new Map();

  var styleEl = document.createElement('style');
  styleEl.textContent =
    '.boost-pfs-search-suggestion-item-product:not([data-vfp-patched]) .boost-pfs-search-suggestion-product-price,' +
    '.boost-pfs-search-suggestion-item-product:not([data-vfp-patched]) .boost-pfs-search-suggestion-product-sale-price,' +
    '.boost-pfs-filter-product-item:not([data-vfp-patched]) .boost-pfs-filter-product-item-price' +
    '{visibility:hidden}';
  (document.head || document.documentElement).appendChild(styleEl);

  var CARD_TYPES = [
    {
      cardSel: '.boost-pfs-search-suggestion-item-product',
      priceSel: '.boost-pfs-search-suggestion-product-sale-price, .boost-pfs-search-suggestion-product-price',
      fromSel: '.boost-pfs-search-suggestion-product-from-text'
    },
    {
      cardSel: '.boost-pfs-filter-product-item',
      priceSel: '.boost-pfs-filter-product-item-sale-price, .boost-pfs-filter-product-item-regular-price',
      fromSel: '.boost-pfs-filter-product-item-price-from-text'
    }
  ];

  function formatMoney(cents) {
    var fmt = (window.boostPFSConfig && window.boostPFSConfig.shop && window.boostPFSConfig.shop.money_format) || '{{amount}}';
    var match = fmt.match(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_space_separator|amount_no_decimals_with_space_separator|amount_with_apostrophe_separator)\s*\}\}/);
    if (!match) return fmt;
    function formatNumber(value, decimals, thousands, decimal) {
      value = (value || 0).toFixed(decimals);
      var parts = value.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return decimals ? intPart + decimal + parts[1] : intPart;
    }
    var value = cents / 100;
    var formatted;
    switch (match[1]) {
      case 'amount_no_decimals': formatted = formatNumber(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': formatted = formatNumber(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': formatted = formatNumber(value, 0, '.', ','); break;
      case 'amount_with_space_separator': formatted = formatNumber(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': formatted = formatNumber(value, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': formatted = formatNumber(value, 2, "'", '.'); break;
      default: formatted = formatNumber(value, 2, ',', '.');
    }
    return fmt.replace(match[0], formatted);
  }

  function fetchSellableMin(handle) {
    if (cache.has(handle)) return cache.get(handle);
    var promise = fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(product) {
        if (!product || !product.variants) return null;
        var sellable = product.variants.filter(function(v) { return v.available; });
        var source = sellable.length ? sellable : product.variants;
        var prices = source.map(function(v) { return v.price; }).filter(function(p) { return p > 0; });
        return prices.length ? Math.min.apply(null, prices) : null;
      })
      .catch(function() { return null; });
    cache.set(handle, promise);
    return promise;
  }

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function patchCard(card, type) {
    if (card.dataset.vfpStarted) return;
    card.dataset.vfpStarted = '1';
    var handle = getHandle(card);
    var target = card.querySelector(type.priceSel);
    if (!handle || !target) {
      card.dataset.vfpPatched = '1';
      return;
    }
    var fallbackTimer = setTimeout(function() {
      card.dataset.vfpPatched = '1';
    }, 1500);
    fetchSellableMin(handle).then(function(cents) {
      clearTimeout(fallbackTimer);
      if (cents != null) {
        var formatted = formatMoney(cents);
        var fromText = target.querySelector(type.fromSel);
        target.innerHTML = (fromText ? fromText.outerHTML + ' ' : '') + formatted;
      }
      card.dataset.vfpPatched = '1';
    });
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    CARD_TYPES.forEach(function(type) {
      root.querySelectorAll(type.cardSel).forEach(function(card) {
        patchCard(card, type);
      });
    });
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        CARD_TYPES.forEach(function(type) {
          if (node.matches && node.matches(type.cardSel)) {
            patchCard(node, type);
          } else if (node.querySelectorAll) {
            node.querySelectorAll(type.cardSel).forEach(function(card) {
              patchCard(card, type);
            });
          }
        });
      });
    });
  });

  document.ready().then(function() {
    observer.observe(document.body, { childList: true, subtree: true });
    scan(document);
  });
})();